import React, { useState,useRef } from "react";
import Dashboard from "../Dashboard/Dashboard";
import "./list.css";
import * as XLSX from 'xlsx';
import CarInsurance from "./allList/CarInsurance/CarInsurancee";
import BikeInsurance from "./allList/BikeInsurance/BikeInsurance";
import HealthInsurance from "./allList/HealthInsurance/HealthInsurance";
import HomeInsurance from "./allList/HomeInsurance/HomeInsurance";
import TermInsurance from "./allList/TermInsurance/TermInsurance";
import GroupInsurance from "./allList/GroupInsurance/GroupInsurance";
import TravelInsurance from "./allList/TravelInsurance/TravelInsurance";
import PersonalInsurance from "./allList/PersonalInsurance/PersonalInsurance";
import Credit from "./allList/Credit/Credit";
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded';
import PersonalLoan from "./allList/PersonalLoan/PersonalLoan";
import HomeLoan from "./allList/HomeLoan/HomeLoan";
import ShopLoan from "./allList/ShopLoan/ShopLoan";
import CarLoan from "./allList/CarLoan/CarLoan";

const ListofServices = () => {
  const [active, setactive] = useState();
  const [data,setData]=useState()

  const exportToExcel = () => {
    // const table = document.getElementById('my-table');
    const worksheet = XLSX.utils.json_to_sheet(data);

    // const worksheet = XLSX.utils.table_to_sheet(table);
    const workbook = XLSX.utils.book_new();

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    // Export the workbook as Excel file
    XLSX.writeFile(workbook, 'table_data.xlsx');
    // setOpenDownload(false)
};

  const changeactive = (value) => {
    setactive(value);
  };
  const role=JSON.parse(localStorage.getItem("userData")).Roles;

  const containerRef = useRef(null);
  const handleMouseDown = (e) => {
    e.preventDefault();
    const container = containerRef.current;
    if (container) {
      const scrollDistance = 400; // Adjust scroll distance as needed
      container.scrollTo({
        left: container.scrollLeft - scrollDistance,
        behavior: 'smooth',
      });
    }
  };
  const handleMouseDown2 = (e) => {
      e.preventDefault();
      const container = containerRef.current;
      if (container) {
        const scrollDistance = 400; // Adjust scroll distance as needed
        container.scrollTo({
          left: container.scrollLeft + scrollDistance,
          behavior: 'smooth',
        });
      }
    };
  return (
    <>
      {/* <Dashboard name={"dashboard"} heading={"List Of Service"} /> */}

        {/* setactive(value); */}

   
       
            <Dashboard name={"dashboard"} heading={"List Of Service"} />

            <div className={role=="Admin"?'main-div':"main-div2"}>
              <div className="row mx-2 align-items-center" style={{whiteSpace:"nowrap"}}>
                <div className="col text-center"><label className="border align-items-center rounded-pill" onMouseDown={handleMouseDown}><ChevronLeftRoundedIcon/></label></div>
                
                <div className='col-8 col-sm-9 col-xl-10 col-xxl-11 border-2 m-2 border p-2 rounded-4'  ref={containerRef} style={{ overflowX: "auto" }}>
                    <div className='row d-flex text-center justify-content-center rounded-4' style={{ width: "2000px", whiteSpace: 'nowrap' }}>
                        <div style={{cursor:"pointer"}} className={active === "car" ? "active2 col p-2 mx-2 rounded" : " mx-2 rounded col p-2"} onClick={() => { changeactive("car") }}>Car Insurance</div>
                        <div style={{cursor:"pointer"}} className={active === "bike" ? "active2 col p-2 rounded mx-2 " : " mx-2 rounded col p-2"} onClick={() => { changeactive("bike") }}>Bike Insurance</div>
                        <div style={{cursor:"pointer"}} className={active === "Health" ? "active2 col p-2 rounded mx-2 " : " mx-2 rounded col p-2"} onClick={() => { changeactive("Health") }}>Health Insurance</div>
                        <div style={{cursor:"pointer"}} className={active === "Home" ? "active2 col p-2 rounded mx-2 " : " mx-2 rounded col p-2"} onClick={() => { changeactive("Home") }}>Home/ Shop Insurance</div>
                        <div style={{cursor:"pointer"}} className={active === "Term" ? "active2 col p-2 rounded mx-2 " : " mx-2 rounded col p-2"} onClick={() => { changeactive("Term") }}>Term Life</div>
                        <div style={{cursor:"pointer"}} className={active === "Group" ? "active2 col p-2 rounded mx-2 " : " mx-2 rounded col p-2"} onClick={() => { changeactive("Group") }}>Group/Coperate</div>
                        <div style={{cursor:"pointer"}} className={active === "Travel" ? "active2 col p-2 rounded mx-2 " : " mx-2 rounded col p-2"} onClick={() => { changeactive("Travel") }}>Travel</div>
                        <div style={{cursor:"pointer"}} className={active === "Personal" ? "active2 col p-2 rounded mx-2 " : " mx-2 rounded col p-2"} onClick={() => { changeactive("Personal") }}>Personal Accident</div>
                        <div style={{cursor:"pointer"}} className={active === "Credit" ? "active2 col p-2 rounded mx-2 " : " mx-2 rounded col p-2"} onClick={() => { changeactive("Credit") }}>Credit Card</div>
                        <div style={{cursor:"pointer"}} className={active === "PersonalLoan" ? "active2 col p-2 rounded mx-2 " : " mx-2 rounded col p-2"} onClick={() => { changeactive("PersonalLoan") }}>Personal Loan</div>
                        <div style={{cursor:"pointer"}} className={active === "HomeLoan" ? "active2 col p-2 rounded mx-2 " : " mx-2 rounded col p-2"} onClick={() => { changeactive("HomeLoan") }}>Home Loan</div>
                        <div style={{cursor:"pointer"}} className={active === "ShopLoan" ? "active2 col p-2 rounded mx-2 " : " mx-2 rounded col p-2"} onClick={() => { changeactive("ShopLoan") }}>Shop Loan</div>
                        <div style={{cursor:"pointer"}} className={active === "CarLoan" ? "active2 col p-2 rounded mx-2 " : " mx-2 rounded col p-2"} onClick={() => { changeactive("CarLoan") }}>Car Loan</div>
                    </div>
                </div>
              
                <div className="col text-center"><label className="border align-items-center rounded-pill" onMouseDown={handleMouseDown2}><ChevronRightRoundedIcon/></label></div>
                </div>
                <div className='m-2 p-2 my-3 '>
                    {active === "car" ? <CarInsurance exportToExcel={exportToExcel} setData={setData}/> 
                    :active === "bike" ? <BikeInsurance exportToExcel={exportToExcel} setData={setData}/>
                    :active === "Health" ? <HealthInsurance exportToExcel={exportToExcel} setData={setData}/>
                    :active === "Home" ? <HomeInsurance exportToExcel={exportToExcel} setData={setData}/>
                    :active === "Term" ? <TermInsurance exportToExcel={exportToExcel} setData={setData}/>
                    :active === "Group" ? <GroupInsurance exportToExcel={exportToExcel} setData={setData}/>
                    :active === "Travel" ? <TravelInsurance exportToExcel={exportToExcel} setData={setData}/>
                    :active === "Personal" ? <PersonalInsurance exportToExcel={exportToExcel} setData={setData}/>
                    :active === "Credit" ? <Credit exportToExcel={exportToExcel} setData={setData}/>
                    :active === "PersonalLoan" ? <PersonalLoan exportToExcel={exportToExcel} setData={setData}/> 
                    :active === "HomeLoan" ? <HomeLoan exportToExcel={exportToExcel} setData={setData}/> 
                    :active === "ShopLoan" ? <ShopLoan exportToExcel={exportToExcel} setData={setData}/>
                    :active === "CarLoan" ? <CarLoan exportToExcel={exportToExcel} setData={setData}/> : <></>
                    }
                </div>
            </div>
            {/* <div
              style={{ cursor: "pointer" }}
              className={
                active === "bike"
                  ? "active2 col p-2 rounded mx-2 "
                  : " mx-2 rounded col p-2"
              }
              onClick={() => {
                changeactive("bike");
              }}
            >
              Bike Insurance
            </div>
            <div
              style={{ cursor: "pointer" }}
              className={
                active === "Health"
                  ? "active2 col p-2 rounded mx-2 "
                  : " mx-2 rounded col p-2"
              }
              onClick={() => {
                changeactive("Health");
              }}
            >
              Health Insurance
            </div>
            <div
              style={{ cursor: "pointer" }}
              className={
                active === "Home"
                  ? "active2 col p-2 rounded mx-2 "
                  : " mx-2 rounded col p-2"
              }
              onClick={() => {
                changeactive("Home");
              }}
            >
              Home/ Shop Insurance
            </div>
            <div
              style={{ cursor: "pointer" }}
              className={
                active === "Term"
                  ? "active2 col p-2 rounded mx-2 "
                  : " mx-2 rounded col p-2"
              }
              onClick={() => {
                changeactive("Term");
              }}
            >
              Term Life
            </div>
            <div
              style={{ cursor: "pointer" }}
              className={
                active === "Group"
                  ? "active2 col p-2 rounded mx-2 "
                  : " mx-2 rounded col p-2"
              }
              onClick={() => {
                changeactive("Group");
              }}
            >
              Group/Corporate{" "}
            </div>
            <div
              style={{ cursor: "pointer" }}
              className={
                active === "Travel"
                  ? "active2 col p-2 rounded mx-2 "
                  : " mx-2 rounded col p-2"
              }
              onClick={() => {
                changeactive("Travel");
              }}
            >
              Travel
            </div>
            <div
              style={{ cursor: "pointer" }}
              className={
                active === "Personal"
                  ? "active2 col p-2 rounded mx-2 "
                  : " mx-2 rounded col p-2"
              }
              onClick={() => {
                changeactive("Personal");
              }}
            >
              Personal Accident
            </div>
            <div
              style={{ cursor: "pointer" }}
              className={
                active === "Credit"
                  ? "active2 col p-2 rounded mx-2 "
                  : " mx-2 rounded col p-2"
              }
              onClick={() => {
                changeactive("Credit");
              }}
            >
              Credit Card
            </div>
            <div
              style={{ cursor: "pointer" }}
              className={
                active === "PersonalLoan"
                  ? "active2 col p-2 rounded mx-2 "
                  : " mx-2 rounded col p-2"
              }
              onClick={() => {
                changeactive("PersonalLoan");
              }}
            >
              Personal Loan
            </div>
            <div
              style={{ cursor: "pointer" }}
              className={
                active === "HomeLoan"
                  ? "active2 col p-2 rounded mx-2 "
                  : " mx-2 rounded col p-2"
              }
              onClick={() => {
                changeactive("HomeLoan");
              }}
            >
              Home Loan
            </div>
            <div
              style={{ cursor: "pointer" }}
              className={
                active === "ShopLoan"
                  ? "active2 col p-2 rounded mx-2 "
                  : " mx-2 rounded col p-2"
              }
              onClick={() => {
                changeactive("ShopLoan");
              }}
            >
              Shop Loan
            </div>
            <div
              style={{ cursor: "pointer" }}
              className={
                active === "CarLoan"
                  ? "active2 col p-2 rounded mx-2 "
                  : " mx-2 rounded col p-2"
              }
              onClick={() => {
                changeactive("CarLoan");
              }}
            >
              Car Loan
            </div>
          </div>
        </div>
        <div className="m-2 p-2 my-3 ">
          {active === "car" ? (
            <CarInsurance />
          ) : active === "bike" ? (
            <BikeInsurance />
          ) : active === "Health" ? (
            <HealthInsurance />
          ) : active === "Home" ? (
            <HomeInsurance />
          ) : active === "Term" ? (
            <TermInsurance />
          ) : active === "Group" ? (
            <GroupInsurance />
          ) : active === "Travel" ? (
            <TravelInsurance />
          ) : active === "Personal" ? (
            <PersonalInsurance />
          ) : active === "Credit" ? (
            <Credit />
          ) : active === "PersonalLoan" ? (
            <PersonalLoan />
          ) : active === "HomeLoan" ? (
            <HomeLoan />
          ) : active === "ShopLoan" ? (
            <ShopLoan />
          ) : active === "CarLoan" ? (
            <CarLoan />
          ) : (
            <></>
          )}
        </div> */}
      {/* </div> */}
    </>
  );
};

export default ListofServices;
